/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SkillLookup { 
    readonly id: string;
    /**
     * UUID of the skill for historical reasons.
     */
    readonly uuid: string;
    /**
     * Zadejte název dovednosti.
     */
    title: string;
    readonly subareaId: number;
    readonly subareaUuid: string;
    readonly areaUuid: string;
    readonly isWatched: boolean;
}